import React, { useEffect, useCallback } from 'react';
import { Row, Col, Radio, Button, Form } from 'antd';

const RadioType = ({
  question,
  selectedAnswer,
  options,
  buttonsState,
  onSubmitAnswer,
  selectedOption,
  setSelectedOption
}) => {
  const [form] = Form.useForm();
  const setFieldValue = useCallback(
    () => {
      setSelectedOption();
      if (selectedAnswer) {
        form.setFieldsValue({ option: selectedAnswer });
        setSelectedOption(selectedAnswer);
      }
    }, [selectedAnswer, question]
  );

  const onFinish = (type) => {
    onSubmitAnswer(type, form.getFieldValue("option"))
    form.resetFields();
  };

  const handleRadioButton = (event) => {
    setSelectedOption(event.target.value);
  };

  useEffect(() => {
    form.resetFields();
    setFieldValue();
  }, [setFieldValue]);

  return (
    <Row justify="center">
      <Form
        initialValues={{ option: selectedAnswer }}
        form={form}
        style={{ width: '100%' }}
      >
        <Col md={24}>
          <Row justify="center">
            <Col md={24} className="options-wrapper p-30 mt-40 mb-80">
              <Row justify="center">
                <Col md={24}>
                  <h2 className="text-center mt-10 mb-50" dangerouslySetInnerHTML={{ __html: question.title && question.title }} />
                </Col>
                <Col md={24}>
                  <Form.Item
                    name="option"
                    onChange={handleRadioButton}
                    className="mb-0"
                  >
                    <Radio.Group
                      style={
                        options.length <= 2 ? { width: '100%', display: 'flex', justifyContent: 'center' } : { width: '100%', display: 'flex', justifyContent: 'space-between' }
                      }
                    >
                      {
                        options && options.map((option, index) =>
                          <Col
                            key={index}
                            style={!question.title ? { width: '48%' } : { width: (100 / (options.length + 1)) + '%' }}
                            className={options.length <= 2 && "two-options-text"}
                          >
                            <Radio.Button
                              value={option.text.toString()}
                              className={question.title ? "radio-button-title" : "radio-button-no-title"}
                              defaultChecked={false}
                            >
                              <p className="mb-0">{option.text}</p>
                            </Radio.Button>
                          </Col>
                        )
                      }
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mb-40">
            <Col md={5}>
              <Button
                className={'secondary-button'}
                size="large"
                onClick={() => onFinish('previus')}
                block
              >
                Anterior
              </Button>
            </Col>
            <Col md={buttonsState.isCurrentLastQuestion ? 12 : 14}></Col>
            <Col md={buttonsState.isCurrentLastQuestion ? 7 : 5} justify="end">
              <Button
                disabled={buttonsState.isCurrentLastQuestion ? !selectedOption : buttonsState.lastQuestion && buttonsState.questionsUnanswered}
                className={(buttonsState.isCurrentLastQuestion ? !selectedOption : buttonsState.lastQuestion && buttonsState.questionsUnanswered)
                  ? 'button-disabled' : ''}
                type="primary"
                size="large"
                onClick={() => onFinish('foward')}
                block
              >
                {buttonsState.isCurrentLastQuestion ? 'Terminar cuestionario' : 'Siguiente'}
              </Button>
            </Col>
          </Row>
        </Col>
      </Form>
    </Row>
  );
};

export default RadioType;